/* ==========================================================================
   Ostrich Golf — Filtrado de colección
   Vanilla JS, sin dependencias. Mejora progresiva sobre el <form> de
   `snippets/collection-filters.liquid`: sin JS el formulario se envía con el
   botón del <noscript> y todo sigue funcionando.

   Qué hace:
     · Abre y cierra los desplegables de filtro (clic fuera, Escape).
     · Al marcar un valor, reconstruye la URL y pide la sección con la Section
       Rendering API (`?section_id=`), reemplazando solo la rejilla y la barra.
     · Mantiene abierto el desplegable en el que estabas y su scroll.
     · Sincroniza el historial del navegador (atrás / adelante funcionan).
   ========================================================================== */
(function () {
  'use strict';

  var pending = null;
  var priceTimer = null;

  function $$(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  /* Todo se resuelve en caliente (nunca se guarda una referencia): la sección
     se repinta al filtrar y también cuando el editor de temas la recarga. */
  function section() {
    return document.querySelector('[data-collection-section]');
  }

  function content() {
    var el = section();
    return el ? el.querySelector('[data-collection-content]') : null;
  }

  function form() {
    var el = section();
    return el ? el.querySelector('[data-collection-filters]') : null;
  }

  /* ----------------------------------------------------------------------
     URL a partir del formulario
     Los mismos filtros se pintan hasta tres veces (desplegable, «Más
     filtros» y panel móvil), así que se descartan los duplicados: un valor
     marcado en dos sitios debe viajar una sola vez.
  ---------------------------------------------------------------------- */
  function buildUrl() {
    var el = form();
    var base = el ? el.getAttribute('action') : window.location.pathname;
    var params = [];
    var seenPairs = {};
    var seenNames = {};

    if (el) {
      $$('input, select', el).forEach(function (field) {
        if (!field.name || field.disabled) return;

        if (field.type === 'checkbox' || field.type === 'radio') {
          if (!field.checked) return;
          var pair = field.name + '=' + field.value;
          if (seenPairs[pair]) return;
          seenPairs[pair] = true;
          params.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
          return;
        }

        var value = (field.value || '').trim();
        if (!value) return;
        if (seenNames[field.name]) return;
        seenNames[field.name] = true;
        params.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(value));
      });
    }

    /* El orden vive en un desplegable propio, no en un <select>: su valor va
       en `data-sort-value` y se añade a mano. */
    var sort = el ? el.querySelector('[data-sort]') : null;
    var sortValue = sort ? sort.dataset.sortValue : '';
    if (sortValue) params.push('sort_by=' + encodeURIComponent(sortValue));

    return params.length ? base + '?' + params.join('&') : base;
  }

  /* ----------------------------------------------------------------------
     Sincronizar copias
     Cada filtro se pinta hasta tres veces (desplegable, «Más filtros» y panel
     móvil). Si el usuario desmarca un valor en una copia y su gemela sigue
     marcada, el valor volvería a viajar en la URL y el filtro parecería no
     poder quitarse. Al tocar un control se copia su estado a sus gemelos.
  ---------------------------------------------------------------------- */
  function syncTwins(field) {
    var el = form();
    if (!el || !field.name) return;
    $$('[name="' + field.name + '"]', el).forEach(function (twin) {
      if (twin === field) return;
      if (field.type === 'checkbox' || field.type === 'radio') {
        if (twin.value === field.value) twin.checked = field.checked;
      } else {
        twin.value = field.value;
      }
    });
  }

  /* ----------------------------------------------------------------------
     Render
  ---------------------------------------------------------------------- */
  function openDropdownParam() {
    var root = section();
    if (!root) return null;
    var open = root.querySelector('[data-filter-dropdown] [data-filter-toggle][aria-expanded="true"]');
    if (!open) return null;
    var holder = open.closest('[data-filter-dropdown]');
    var panel = holder ? holder.querySelector('[data-filter-panel]') : null;
    return {
      param: holder ? holder.dataset.filterParam : null,
      scroll: panel ? panel.scrollTop : 0
    };
  }

  function restoreDropdown(state) {
    if (!state || !state.param) return;
    var root = section();
    if (!root) return;
    var holder = root.querySelector('[data-filter-dropdown][data-filter-param="' + state.param + '"]');
    if (!holder) return;
    toggleDropdown(holder, true);
    var panel = holder.querySelector('[data-filter-panel]');
    if (panel) panel.scrollTop = state.scroll;
  }

  function setBusy(busy) {
    var el = content();
    if (!el) return;
    el.style.opacity = busy ? '0.55' : '';
    el.style.transition = 'opacity .2s';
    el.style.pointerEvents = busy ? 'none' : '';
  }

  function render(url, push) {
    var root = section();
    if (!root) return;
    var drawerOpen = !!root.querySelector('[data-filters-drawer]:not(.hidden)');
    var dropdown = openDropdownParam();
    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + root.dataset.sectionId;

    if (pending) pending.abort();
    pending = typeof AbortController === 'function' ? new AbortController() : null;
    setBusy(true);

    fetch(fetchUrl, { signal: pending ? pending.signal : undefined })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-collection-content]');
        var current = content();
        if (!fresh || !current) return;

        current.innerHTML = fresh.innerHTML;
        setBusy(false);

        if (push !== false) window.history.pushState({ collectionUrl: url }, '', url);

        /* Las tarjetas nuevas necesitan que main.js repase el panel de tallas. */
        document.dispatchEvent(new CustomEvent('section:updated', { detail: { url: url } }));

        restoreDropdown(dropdown);
        if (drawerOpen) openDrawer();
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        setBusy(false);
        window.location.href = url;
      });
  }

  function apply() {
    render(buildUrl(), true);
  }

  /* ----------------------------------------------------------------------
     Desplegables
  ---------------------------------------------------------------------- */
  function toggleDropdown(holder, open) {
    var button = holder.querySelector('[data-filter-toggle]');
    var panel = holder.querySelector('[data-filter-panel]');
    if (!button || !panel) return;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    var chevron = button.querySelector('[data-filter-chevron]');
    if (chevron) chevron.classList.toggle('rotate-180', open);
  }

  function closeDropdowns(except) {
    var root = section() || document;
    $$('[data-filter-dropdown]', root).forEach(function (holder) {
      if (holder !== except) toggleDropdown(holder, false);
    });
    $$('[data-sort-details]', root).forEach(function (details) {
      if (details !== except) details.open = false;
    });
  }

  /* ----------------------------------------------------------------------
     Panel móvil
  ---------------------------------------------------------------------- */
  function openDrawer() {
    var root = section();
    var drawer = root ? root.querySelector('[data-filters-drawer]') : null;
    if (!drawer) return;
    drawer.classList.remove('hidden');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      var panel = drawer.querySelector('[data-filters-drawer-panel]');
      if (panel) panel.classList.remove('translate-x-full');
    });
  }

  function closeDrawer() {
    var root = section();
    var drawer = root ? root.querySelector('[data-filters-drawer]') : null;
    if (!drawer) return;
    var panel = drawer.querySelector('[data-filters-drawer-panel]');
    if (panel) panel.classList.add('translate-x-full');
    document.documentElement.style.overflow = '';
    window.setTimeout(function () {
      drawer.classList.add('hidden');
    }, 280);
  }

  /* ----------------------------------------------------------------------
     Eventos (delegados: el contenido se reemplaza en cada filtrado)
  ---------------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-collection-section]')) {
      closeDropdowns(null);
      return;
    }

    var sortOption = event.target.closest('[data-sort-option]');
    if (sortOption) {
      event.preventDefault();
      var sortHolder = sortOption.closest('[data-sort]');
      var details = sortOption.closest('[data-sort-details]');
      if (sortHolder) sortHolder.dataset.sortValue = sortOption.value;
      if (details) details.open = false;
      apply();
      return;
    }

    /* Al abrir el desplegable de orden se cierran los de filtro, y al revés. */
    var sortSummary = event.target.closest('[data-sort-details] > summary');
    if (sortSummary) {
      closeDropdowns(sortSummary.parentElement);
      return;
    }

    var toggle = event.target.closest('[data-filter-toggle]');
    if (toggle) {
      event.preventDefault();
      var holder = toggle.closest('[data-filter-dropdown]');
      var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      closeDropdowns(holder);
      toggleDropdown(holder, willOpen);
      return;
    }

    if (event.target.closest('[data-filters-open]')) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-filters-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var clear = event.target.closest('[data-filter-clear]');
    if (clear) {
      event.preventDefault();
      var panel = clear.closest('[data-filter-panel]');
      if (!panel) return;
      $$('input', panel).forEach(function (field) {
        if (field.type === 'checkbox' || field.type === 'radio') field.checked = false;
        else field.value = '';
        syncTwins(field);
      });
      apply();
      return;
    }

    if (event.target.closest('[data-filter-clear-all]')) {
      event.preventDefault();
      var el = form();
      if (el) {
        $$('input', el).forEach(function (field) {
          if (field.type === 'checkbox' || field.type === 'radio') field.checked = false;
          else field.value = '';
        });
      }
      apply();
      return;
    }

    var chip = event.target.closest('[data-filter-remove]');
    if (chip) {
      event.preventDefault();
      var names = [chip.dataset.name];
      if (chip.dataset.extraName) names.push(chip.dataset.extraName);
      var value = chip.dataset.value;
      var container = form();
      if (container) {
        names.forEach(function (name) {
          $$('[name="' + name + '"]', container).forEach(function (field) {
            if (field.type === 'checkbox' || field.type === 'radio') {
              if (value == null || field.value === value) field.checked = false;
            } else {
              field.value = '';
            }
          });
        });
      }
      apply();
      return;
    }

    /* Clic fuera de los desplegables: se cierran. */
    if (!event.target.closest('[data-filter-dropdown]')) closeDropdowns(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      closeDropdowns(null);
      closeDrawer();
    }
  });

  document.addEventListener('change', function (event) {
    var field = event.target;
    if (!field.name || !field.closest('[data-collection-section]')) return;
    if (field.matches('[data-filter-price]')) {
      window.clearTimeout(priceTimer);
      syncTwins(field);
      apply();
      return;
    }
    if (field.matches('[data-filter-input]')) {
      syncTwins(field);
      apply();
    }
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-filter-price]')) return;
    if (!event.target.closest('[data-collection-section]')) return;
    syncTwins(event.target);
    window.clearTimeout(priceTimer);
    priceTimer = window.setTimeout(apply, 700);
  });

  document.addEventListener('submit', function (event) {
    if (!event.target.matches('[data-collection-filters]')) return;
    event.preventDefault();
    apply();
  });

  /* Paginación sin recarga, conservando los filtros. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-collection-content] a[href*="page="]');
    if (!link) return;
    event.preventDefault();
    render(link.getAttribute('href'), true);
    var root = section();
    if (root) window.scrollTo({ top: root.offsetTop - 80, behavior: 'smooth' });
  });

  window.addEventListener('popstate', function () {
    if (!section()) return;
    render(window.location.pathname + window.location.search, false);
  });
})();
